import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-592e7779"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "floating-video-box"
};
const _hoisted_2 = {
  class: "video-cover"
};
const _hoisted_3 = ["src", "alt"];

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "video-overlay"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "play-btn"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://prod-polymas-oss.polymas.com/polymas-basic-resource/YkX3ld/oukTlR_OqJBj7/69a7ec84e4b026fef9ff2f13.png",
  alt: "play"
})])], -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "video-gradient"
}, null, -1));

const _hoisted_6 = {
  class: "video-title"
};
const _hoisted_7 = {
  class: "video-cover"
};
const _hoisted_8 = ["src", "alt"];

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "video-overlay"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "play-btn"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://prod-polymas-oss.polymas.com/polymas-basic-resource/YkX3ld/oukTlR_OqJBj7/69a7ec84e4b026fef9ff2f13.png",
  alt: "play"
})])], -1));

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "video-gradient"
}, null, -1));

const _hoisted_11 = {
  class: "video-title"
};
import { ref, reactive } from 'vue';
import VideoPlayDialog from './VideoPlayDialog.vue';
export default {
  setup(__props) {
    const showVideoDialog = ref(false);
    const videoInfo = reactive({
      url: '',
      title: '',
      cover: ''
    });
    const studentVideo = reactive({
      title: '学生端使用视频',
      cover: 'https://prod-polymas-oss.polymas.com/polymas-basic-resource/YkX3ld/UugXaA_vlgkiI/69a7e84be4b09cb3d57e3331.png',
      url: 'https://prod-polymas-oss.polymas.com/polymas-basic-resource/YkX3ld/UugXaA_vlgkiI/69a7ce2de4b0eb566cf8b93a.mp4'
    });
    const teacherVideo = reactive({
      title: '老师端使用视频',
      cover: 'https://prod-polymas-oss.polymas.com/polymas-basic-resource/YkX3ld/UugXaA_vlgkiI/69a7e852e4b0a7b9d9201b90.png',
      url: 'https://prod-polymas-oss.polymas.com/polymas-basic-resource/YkX3ld/UugXaA_vlgkiI/69a7ce10e4b09cb3fb819b3b.mp4'
    });

    const handleVideoClick = video => {
      if (video.url) {
        videoInfo.url = video.url;
        videoInfo.title = video.title;
        videoInfo.cover = video.cover;
        showVideoDialog.value = true;
      }
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: "video-item",
        onClick: _cache[0] || (_cache[0] = $event => handleVideoClick(_unref(teacherVideo)))
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        src: _unref(teacherVideo).cover,
        alt: _unref(teacherVideo).title
      }, null, 8, _hoisted_3), _hoisted_4, _hoisted_5, _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(teacherVideo).title), 1)])]), _createElementVNode("div", {
        class: "video-item",
        onClick: _cache[1] || (_cache[1] = $event => handleVideoClick(_unref(studentVideo)))
      }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
        src: _unref(studentVideo).cover,
        alt: _unref(studentVideo).title
      }, null, 8, _hoisted_8), _hoisted_9, _hoisted_10, _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(studentVideo).title), 1)])])]), _createVNode(VideoPlayDialog, {
        show: showVideoDialog.value,
        "onUpdate:show": _cache[2] || (_cache[2] = $event => showVideoDialog.value = $event),
        videoInfo: _unref(videoInfo)
      }, null, 8, ["show", "videoInfo"])], 64);
    };
  }

};